




import {Component, Prop, Vue} from "vue-property-decorator";
import {RegionStore} from "../store";

@Component({
    name: "CountryLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly id!: number;

    get label(): string {
        const country = RegionStore.countryIdMapper[this.id];
        return `${country?.code} - ${country?.name}`;
    }
}
